module.exports = __webpack_public_path__ + "static/project_financing-31b5270de4c87ea00a5f3818d6001ad8.jpg";